
function VideoCardsBlock() {
    for (let videoCardsBlock of document.querySelectorAll('.video-cards-block')) {
        let lightbox = videoCardsBlock.querySelector('.lightbox');
        let container = lightbox.querySelector('.content');
        let next = lightbox.querySelector('.next');
        let previous = lightbox.querySelector('.previous');
        let close = lightbox.querySelector('.close');
        let facades = videoCardsBlock.querySelectorAll('.facade');
        let videos = videoCardsBlock.querySelectorAll('.video');
        let players = [];
        let active = null;
        for (let index = 0; index < facades.length; index = index + 1) {
            let facade = facades[index];
            let video = videos[index];
            /*let videoId = new URL(video.getAttribute('src')).pathname.slice('/embed/'.length);
            fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`)
            .then(function(response) {
                return response.json();
            }).then(function(details) {
                facade.style.setProperty('aspect-ratio', `${details.width} / ${details.height}`);
                video.style.setProperty('aspect-ratio', `${details.width} / ${details.height}`);
            });*/
            facade.addEventListener('mouseover', function() {
                if (video.getAttribute('loading') === 'lazy') {
                    video.setAttribute('loading', 'eager');
                }
            });
            let player = new YT.Player(video, {
                events: {
                    onReady: function(event) {
                        /*let player = event.target;*/
                        console.log("readyPlayer", player);
                    }
                }
            });
            players[index] = player;
            facade.addEventListener('click', function() {
                if (typeof player.playVideo === 'function') {
                    player.playVideo();
                }
                else {
                    player.addEventListener('onReady', function(event) {
                        player.playVideo();
                    });
                }
                video.removeAttribute('hidden');
                lightbox.removeAttribute('hidden');
                let content = video;
                let facadeBoundingRectangle = facade.getBoundingClientRect();
                let contentBoundingRectangle = content.getBoundingClientRect();
                lightbox.animate([
                    {
                        opacity: "0",
                    },
                    {
                        opacity: "1",
                    },
                ], { duration: 500, easing: 'ease-in' });
                container.animate([
                    {
                        width: `${container.offsetWidth}px`,
                        height: `${container.offsetHeight}px`,
                    },
                ], { duration: 500, easing: 'step-start' });
                content.animate([
                    {
                        position: "relative",
                        width: `${facade.offsetWidth}px`,
                        height: `${facade.offsetHeight}px`,
                        top: `${facadeBoundingRectangle.top - contentBoundingRectangle.top}px`,
                        left: `${facadeBoundingRectangle.left - contentBoundingRectangle.left}px`,
                    },
                    {
                        position: "relative",
                        width: `${content.offsetWidth}px`,
                        height: `${content.offsetHeight}px`,
                        top: "0",
                        left: "0",
                    },
                ], { duration: 500, easing: 'ease' });
                if (index === 0) {
                    previous.setAttribute('hidden', 'hidden');
                }
                else {
                    previous.removeAttribute('hidden');
                }
                if (index === facades.length - 1) {
                    next.setAttribute('hidden', 'hidden')
                }
                else {
                    next.removeAttribute('hidden');
                }
                active = index;
            });
        }
        next.addEventListener('mouseover', function() {
            let video = videos[active + 1];
            if (video.getAttribute('loading') === 'lazy') {
                video.setAttribute('loading', 'eager');
            }
        });
        previous.addEventListener('mouseover', function() {
            let video = videos[active - 1];
            if (video.getAttribute('loading') === 'lazy') {
                video.setAttribute('loading', 'eager');
            }
        });
        next.addEventListener('click', function() {
            previous.removeAttribute('hidden');
            let currentVideo = videos[active];
            let player = players[active];
            if (typeof player.pauseVideo === 'function') {
                player.pauseVideo();
            }
            else {
                player.addEventListener('onReady', function() {
                    player.pauseVideo();
                });
            }
            let animation = currentVideo.animate([
                {
                    position: "absolute",
                    left: `${currentVideo.offsetLeft}px`,
                    top: `${currentVideo.offsetTop}px`,
                    opacity: "1",
                },
                {
                    position: "absolute",
                    left: `calc(${currentVideo.offsetLeft}px - 50%)`,
                    top: `${currentVideo.offsetTop}px`,
                    opacity: "0",
                },
            ], { duration: 300, easing: "ease-out" });
            animation.addEventListener("finish", function() {
                currentVideo.setAttribute('hidden', 'hidden');
            });
            active = active + 1;
            let nextVideo = videos[active];
            player = players[active];
            if (typeof player.playVideo === 'function') {
                player.playVideo();
            }
            else {
                player.addEventListener('onReady', function() {
                    player.playVideo();
                });
            }
            nextVideo.removeAttribute('hidden');
            nextVideo.animate([
                {
                    position: "relative",
                    left: "50%",
                    opacity: "0",
                },
                {
                    position: "relative",
                    left: "0",
                    opacity: "1",
                },
            ], { duration: 300, easing: "ease-out" });
            if (active === facades.length - 1) {
                next.setAttribute('hidden', 'hidden');
            }
            else {
                nextVideo = videos[active + 1];
                if (nextVideo.getAttribute('loading') === 'lazy') {
                    nextVideo.setAttribute('loading', 'eager');
                }
            }
        });
        previous.addEventListener('click', function() {
            next.removeAttribute('hidden');
            let currentVideo = videos[active];
            let currentPlayer = players[active];
            if (typeof currentPlayer.pauseVideo === 'function') {
                currentPlayer.pauseVideo();
            }
            else {
                currentPlayer.addEventListener('onReady', function() {
                    currentPlayer.pauseVideo();
                });
            }
            let animation = currentVideo.animate([
                {
                    position: "absolute",
                    left: `${currentVideo.offsetLeft}px`,
                    top: `${currentVideo.offsetTop}px`,
                    opacity: "1",
                },
                {
                    position: "absolute",
                    left: `calc(${currentVideo.offsetLeft}px + 50%)`,
                    top: `${currentVideo.offsetTop}px`,
                    opacity: "0",
                },
            ], { duration: 300, easing: "ease-out" });
            animation.addEventListener("finish", function() {
                currentVideo.setAttribute('hidden', 'hidden');
            });
            active = active - 1;
            let previousVideo = videos[active];
            let previousPlayer = players[active];
            if (typeof previousPlayer.playVideo === 'function') {
                previousPlayer.playVideo();
            }
            else {
                previousPlayer.addEventListener('onReady', function() {
                    previousPlayer.playVideo();
                });
            }
            previousVideo.removeAttribute('hidden');
            previousVideo.animate([
                {
                    position: "relative",
                    left: "-50%",
                    opacity: "0",
                },
                {
                    position: "relative",
                    left: "0",
                    opacity: "1",
                },
            ], { duration: 300, easing: "ease-out" });
            if (active === 0) {
                previous.setAttribute('hidden', 'hidden');
            }
            else {
                previousVideo = videos[active - 1];
                if (previousVideo.getAttribute('loading') === 'lazy') {
                    previousVideo.setAttribute('loading', 'eager');
                }
            }
        });
        close.addEventListener('click', function() {
            let facade = facades[active];
            let video = videos[active];
            let player = players[active];
            let facadeBoundingRectangle = facade.getBoundingClientRect();
            let videoBoundingRectangle = video.getBoundingClientRect();
            lightbox.animate([
                {
                    opacity: "1",
                },
                {
                    opacity: "0",
                },
            ], { duration: 500, easing: 'ease-out' });
            container.animate([
                {
                    width: `${container.offsetWidth}px`,
                    height: `${container.offsetHeight}px`,
                },
            ], { duration: 500, easing: 'step-start' });
            let animation = video.animate([
                {
                    position: "relative",
                    width: `${video.offsetWidth}px`,
                    height: `${video.offsetHeight}px`,
                    top: "0",
                    left: "0",
                },
                {
                    position: "relative",
                    width: `${facade.offsetWidth}px`,
                    height: `${facade.offsetHeight}px`,
                    top: `${facadeBoundingRectangle.top - videoBoundingRectangle.top}px`,
                    left: `${facadeBoundingRectangle.left - videoBoundingRectangle.left}px`,
                },
            ], { duration: 500, easing: 'ease' });
            animation.addEventListener('finish', function() {
                lightbox.setAttribute('hidden', 'hidden');
                video.setAttribute('hidden', 'hidden');
            });
            if (typeof player.pauseVideo === 'function') {
                player.pauseVideo();
            }
            else {
                player.addEventListener('onReady', function() {
                    player.pauseVideo();
                });
            }
            active = null;
        });
        /*
        let lightboxContent = lightbox.querySelector('.content');*/
        //for (let cardVideo of videoCardsBlock.querySelectorAll('.video')) {
            //let iframe = cardVideo.querySelector('iframe');
            //let playButton = cardVideo.querySelector('button');
            /*playButton.addEventListener('click', function() {
                console.log("Play!");
            });*/
            //let thumbnail = playButton.querySelector('.thumbnail');
            /*let thumbnail = youtubeVideo.querySelector('.thumbnail');
            let playIcon = youtubeVideo.querySelector('.play-icon');
            let playIconHover = youtubeVideo.querySelector('.play-icon.hover');*/
            //let videoId = new URL(iframe.getAttribute('src')).pathname.slice('/embed/'.length);
            //fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`)
            //.then(function(response) {
            //    return response.json();
            //}).then(function(details) {
            //    iframe.style.setProperty('aspect-ratio', `${details.width} / ${details.height}`);
            //});
            //new YT.Player(iframe, {
            //    events: {
            //        onReady: function(event) {
            //            let player = event.target;
            //            playButton.addEventListener('click', function() {
            //                player.playVideo();
            //                playButton.setAttribute('hidden', 'hidden');
            //                /*lightboxContent.appendChild(iframe);*/
            //                lightbox.removeAttribute('hidden');
            //                /*thumbnail.setAttribute('hidden', 'hidden');
            //                playIcon.setAttribute('hidden', 'hidden');
            //                playIconHover.setAttribute('hidden', 'hidden');*/
            //            });
            //        },
            //        onStateChange: function(event) {
            //            let playerState = event.data;
            //            console.log(event, playerState);
            //            if (playerState == 2) {
            //                playButton.removeAttribute('hidden');
            //                /*thumbnail.removeAttribute('hidden');
            //                playIcon.removeAttribute('hidden');
            //                playIconHover.removeAttribute('hidden');*/
            //            }
            //        }
            //    }
            //});
        //}
    }
}

if (typeof YT !== 'undefined' && YT.loaded) {
    VideoCardsBlock();
}
else if (window.hasOwnProperty('onYouTubeIframeAPIReady')) {
    let onYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function() {
        onYouTubeIframeAPIReady();
        VideoCardsBlock();
    }
}
else {
    window.onYouTubeIframeAPIReady = VideoCardsBlock;
}
